// @flow

import { jsonResponse } from "fetch-utilities";
import type { Fetch }   from "fetch-utilities";

const requestedCodes  = i => i.map(i => i.requestedQty).reduce((a, b) => a + b, 0);
const waitingForCodes = i => requestedCodes(i) > i.map(i => i.codes.length).reduce((a, b) => a + b, 0);

export const LOADED  = "store/serialcodes/LOADED";
export const LOADING = "store/serialcodes/LOADING";
export const PENDING = "store/serialcodes/PENDING";

const initialState = {
  state           : PENDING,
  obtainedCodes   : [],
  requestedCodes  : null,
  waitingForCodes : null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        state: LOADING
      };

    case LOADED:
      return {
        ...state,
        state           : LOADED,
        requestedCodes  : requestedCodes(action.payload),
        obtainedCodes   : action.payload,
        waitingForCodes : waitingForCodes(action.payload),
      };

    default:
      return state;
  }
}

export const load = () => (dispatch: Function, getState: Function, client: Fetch) => {
  dispatch({
    type: LOADING
  });

  dispatch({
    type    : LOADED,
    payload : client("/serialcodes_order").then(jsonResponse).catch(() => [])
  });
};
